import { ITimezoneItem } from "../config";

// internal cache
let cachedCanonicalTimezones: ITimezoneItem[] | null = null;

const DEPRECATED_PREFIXES = [
  'Etc/',
  'GMT',
  'UTC',
  'UCT',
  'US/',
  'Canada/',
  'Mexico/',
  'Brazil/',
  'SystemV/',
  'Universal',
  'Zulu',
  'W-SU',
];

// Exact deprecated aliases
const DEPRECATED_EXACT = new Set([
  'CET',
  'CST6CDT',
  'EET',
  'EST',
  'EST5EDT',
  'HST',
  'MET',
  'MST',
  'MST7MDT',
  'PST8PDT',
  'WET',
]);

function buildCanonicalTimezones(): ITimezoneItem[] {
  let tzList: string[] = [];

  try {
    tzList = Intl.supportedValuesOf('timeZone');
  } catch {
    tzList = [Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'];
  }

  const filtered = tzList.filter((tz) => {
    if (DEPRECATED_EXACT.has(tz)) return false;
    return !DEPRECATED_PREFIXES.some((prefix) => tz.startsWith(prefix));
  });

  const mapped: ITimezoneItem[] = filtered.map((tz) => {
    const parts = tz.split('/');
    let city = parts[parts.length - 1] || tz;
    let region = parts.length > 1 ? parts[0] : '';

    city = city.replace(/_/g, ' ');
    region = region.replace(/_/g, ' ');

    city = city.charAt(0).toUpperCase() + city.slice(1);
    region = region.charAt(0).toUpperCase() + region.slice(1);

    return {
      name: region ? `${city}, ${region}` : city,
      tzCode: tz,
    };
  });

  // optional: stable sort by region -> city
  mapped.sort((a, b) => {
    const [cityA, regionA = ''] = a.name.split(', ');
    const [cityB, regionB = ''] = b.name.split(', ');
    if (regionA === regionB) return cityA.localeCompare(cityB);
    return regionA.localeCompare(regionB);
  });

  return mapped;
}

export function getTimezonesList(): ITimezoneItem[] {
  if (!cachedCanonicalTimezones) {
    cachedCanonicalTimezones = buildCanonicalTimezones();
  }
  return cachedCanonicalTimezones;
}